/**
 * Where the client sends Cloud Function calls.
 *
 * Production goes through the Hosting rewrites in firebase.json (`/api/<fn>`), so
 * the browser stays same-origin. A plain `npm run dev` talks to the deployed
 * functions. The local e2e harness (scripts/e2e-local.sh) sets
 * VITE_FUNCTIONS_BASE_URL to the functions emulator so nothing leaves the machine.
 */
export const FUNCTIONS_BASE_URL: string =
  import.meta.env.VITE_FUNCTIONS_BASE_URL ||
  (import.meta.env.PROD ? '/api' : 'https://us-central1-day-one-workshop.cloudfunctions.net')
